import Swiper from 'swiper';
import { Navigation, A11y } from 'swiper/modules';

import 'swiper/css';
import './teaser-themenwelten.scss';

class ThemenweltenSlider {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-themenwelten-slider',
            sliderAttr: 'main',
            slideAttr: 'slide'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$themenwelten = $element;
        this.$themenweltenContainer = this.$themenwelten.querySelector(`[${this.settings.initAttr}="${this.settings.sliderAttr}"]`);
        this.$themenweltenSlides = this.$themenwelten.querySelectorAll(`[${this.settings.initAttr}="${this.settings.slideAttr}"]`);
        this.themenweltenSlider = null;
        this.$themenweltenTopicCheckboxes = document.querySelectorAll('[data-themenwelten-topic="checkbox"]');

        if (this.$themenweltenContainer && this.$themenweltenSlides.length > 1) {
            this.initialize();
        }
    }

    initialize () {
        this.checkSize();
        this.setEvents();
        this.changeTopic();
    }

    checkSize () {
        if (window.mediaMatch[1024].matches && this.$themenweltenSlides.length > 1) {
            if (this.themenweltenSlider === null) {
                this.initSlider();
            }
        } else {
            if (this.themenweltenSlider !== null) {
                this.destroySlider();
            }
        }
    }

    setEvents () {
        [1024].forEach((bp) => {
            window.mediaMatch[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });

        const $allLabels = document.querySelectorAll('[data-themenwelten-topic-label]');
        $allLabels.forEach($currentLabel => {
            $currentLabel.onclick = () => {
                $allLabels.forEach($label => {
                    if ($currentLabel !== $label) {
                        $label.setAttribute('aria-pressed', 'false');
                    }
                });

                $currentLabel.querySelector('[data-themenwelten-topic-toggle]').click();
                $currentLabel.setAttribute('aria-pressed', 'true');
            };
        });
    }

    initSlider () {
        const prevBTN = this.$themenweltenContainer.querySelector('.swiper-button-prev');
        const nextBTN = this.$themenweltenContainer.querySelector('.swiper-button-next');
        this.themenweltenSlider = new Swiper(this.$themenweltenContainer, {
            modules: [Navigation, A11y],
            speed: 500,
            effect: 'fade',
            slidesPerView: 3,
            spaceBetween: 40,
            a11y: {
                prevSlideMessage: 'Vorheriger Slide',
                nextSlideMessage: 'Nächster Slide'
            },
            navigation: {
                prevEl: prevBTN,
                nextEl: nextBTN,
                addIcons: false,
            }
        });
    }

    changeTopic () {
        let $activeTopicSlider;
        let activeId = 1;

        this.$themenweltenTopicCheckboxes.forEach($topicCheckbox => {
            $topicCheckbox.onchange = () => {
                const $allSliders = document.querySelectorAll('[data-themenwelten-topic-slider]');
                $allSliders.forEach($slider => {
                    $slider.classList.remove('is--visible');
                });

                if ($topicCheckbox.checked === true) {
                    activeId = $topicCheckbox.dataset.inputId;
                    $activeTopicSlider = document.querySelector(`[data-themenwelten-topic-slider="${activeId}"]`);
                    $activeTopicSlider.classList.add('is--visible');
                }
            };
        });
    }

    destroySlider () {
        if (this.themenweltenSlider !== null) {
            this.themenweltenSlider.destroy(true, true);
            this.themenweltenSlider = null;
        }
    }
}

export { ThemenweltenSlider };

window.addEventListener('content.loaded', (e) => {
    const $context = e.detail.$context;

    if ($context) {
        const $$ThemenweltenSlider = $context.querySelectorAll('[data-themenwelten-slider="root"]');

        for (let i = 0; i < $$ThemenweltenSlider.length; i++) {
            const $ThemenweltenSlider = $$ThemenweltenSlider[i];
            const ThemenweltenSliderAPI = new ThemenweltenSlider($ThemenweltenSlider);
            $ThemenweltenSlider.API = ThemenweltenSliderAPI;
        }
    }
});
